import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionSummary, Typography } from '@mui/material';
// import { ExpandMoreIcon } from '../assets/images';
export default function MuiAccordion(props) {
    var _a = props.title, title = _a === void 0 ? 'Accordion' : _a, style = props.style, children = props.children, onClick = props.onClick, titleVariant = props.titleVariant;
    return /*#__PURE__*/ React.createElement(Accordion, {
        sx: style
    }, /*#__PURE__*/ React.createElement(AccordionSummary, {
        expandIcon: /*#__PURE__*/ React.createElement(ExpandMoreIcon, null),
        onClick: onClick,
        "aria-controls": "panel1a-content",
        id: "panel1a-header"
    }, /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            width: "100%"
        },
        variant: titleVariant !== null && titleVariant !== void 0 ? titleVariant : 'body1'
    }, title)), children);
}
